import { useState } from 'react';

interface VehicleGalleryProps {
  images: string[];
  title: string;
}

export default function VehicleGallery({ images, title }: VehicleGalleryProps) {
  const [selectedImage, setSelectedImage] = useState(0);

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      {/* Main Image */}
      <div className="relative w-full h-[500px] bg-gray-100">
        <img
          src={images[selectedImage]}
          alt={title}
          className="w-full h-full object-cover"
        />
        
        {/* Navigation Arrows */}
        {images.length > 1 && (
          <>
            <button
              onClick={() => setSelectedImage(prev => prev === 0 ? images.length - 1 : prev - 1)}
              className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/90 hover:bg-white rounded-full shadow-lg transition-all cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-2xl text-gray-900"></i>
            </button>
            <button
              onClick={() => setSelectedImage(prev => prev === images.length - 1 ? 0 : prev + 1)}
              className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/90 hover:bg-white rounded-full shadow-lg transition-all cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-2xl text-gray-900"></i>
            </button>
          </>
        )}

        {/* Image Counter */}
        <div className="absolute bottom-4 right-4 px-4 py-2 bg-black/70 text-white text-sm font-medium rounded-lg">
          {selectedImage + 1} / {images.length}
        </div>
      </div>

      {/* Thumbnail Strip */}
      {images.length > 1 && (
        <div className="p-4 bg-gray-50">
          <div className="flex gap-3 overflow-x-auto">
            {images.map((image, index) => (
              <button
                key={index}
                onClick={() => setSelectedImage(index)}
                className={`flex-shrink-0 w-24 h-20 rounded-lg overflow-hidden border-2 transition-all cursor-pointer ${
                  selectedImage === index
                    ? 'border-teal-500 ring-2 ring-teal-200'
                    : 'border-gray-200 hover:border-gray-300'
                }`}
              >
                <img
                  src={image}
                  alt={`${title} - View ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
